export default {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
  baseUrl: process.env.REACT_APP_URL,
};
